export type tabType = {
    index: number,
    title: string
}

export const DEFAULT_TAB:tabType = {
    index: 0,
    title: 'Default'
}

export const TABS: { [key: string]: tabType } = {
    SIZE: {
        index: 1,
        title: 'Size'
    },
    COLOR: {
        index: 2,
        title: 'Base Color'
    },
    IMAGE: {
        index: 3,
        title: 'Add Image'
    },
    TEXT: {
        index: 4,
        title: "Add Text"
    },
    CART: {
        index: 5,
        title: "Add to cart"
    }
}

export const TAB_OVERLAYS: { [key: string]: tabType } = {
    ADD_TEXT: {
        index: 6,
        title: "Add Text"
    }
}

export const SUB_TABS_TEXT: { [key: string]: tabType } = {
    TEXT: {
        index: 1,
        title: "Text",
    },
    FONT: {
        index: 2,
        title: "Font",
    },
    COLOR: {
        index: 3,
        title: "Color"
    },
    OUTLINE: {
        index: 4,
        title: "Outline"
    },
    MORE: {
        index: 5,
        title: 'More'
    },
    LAYERS: {
        index: 6,
        title: 'Layers'
    }
}

export const SUB_TABS_IMAGE: { [key: string]: tabType } = {
    DELETE: {
        index: 1,
        title: "Delete",
    },
    DUPLICATE: {
        index: 2,
        title: "Duplicate",
    },
    FLIP_V: {
        index: 3,
        title: "Flip V",
    },
    FLIP_H: {
        index: 4,
        title: "Flip H"
    },
    ALIGN_LEFT: {
        index: 5,
        title: "Align Left"
    },
    ALIGN_RIGHT: {
        index: 6,
        title: 'Align right'
    },
    ALIGN_CENTER: {
        index: 7,
        title: 'Align center'
    },
    ALIGN_TOP: {
        index: 8,
        title: 'Align top'
    },
    ALIGN_BOTTOM: {
        index: 9,
        title: 'Align bottom'
    },
    BRING_FRONT: {
        index: 10,
        title: 'Bring to front'
    },
    SEND_BACK:{
        index: 11,
        title: 'Send to back'
    }
}

export const ADD_TEXT = 'Add Text';